module.exports = __webpack_public_path__ + "img/merit_icon1.577a6a6e.png";